import React from 'react'
import PropertyGrid from '../../../components/PropertyGrid'
import { Link } from 'react-router-dom'
import slugify from 'react-slugify'
import { useTranslation } from 'react-i18next'
import { Account, Filter } from '../store/store'
import AlertText from '../../../components/text/AlertText'
import WarningText from '../../../components/text/WarningText'
import Date from '../../../components/Date'
import { useHistory } from 'react-router-dom'

type Props = {
  partnerId: string
  account: Account
}

function AccountsRowCompact(props: Props) {
  const { account, partnerId } = props
  const { t } = useTranslation(['accounts', 'global'])
  const history = useHistory()

  return (
    <>
      <div id={`${slugify(account.name)}-compact-header`} className="header-cell flex-justify-start">
        <b>{account.name}</b>
        <div className="action-container">
          <a
            href={`${process.env.REACT_APP_WEPAPP_URL}/accounts/${account.id}`}
            target="_blank"
            rel="noopener noreferrer">
            <i className="far fa-window-maximize icon-button web-expand"></i>
          </a>
          <span data-cy="btn-admin-account" onClick={() => history.push(`/account/${account.id}/settings`)}>
            <i className="fas fa-cog icon-button"></i>
          </span>   
        </div>
      </div>

      <div data-cy={slugify(account.name)} className="accounts-responsive-outer">
        <PropertyGrid
          properties={{
            [t('fields.subscription')]: (
              <Link to={`/partner/${partnerId}/subscriptions?subscription=${account.subscription.id}`}>
                {account.subscription.name}
              </Link>
            ),
            [t('fields.last_activity')]: (
              <div className="subscription-records">
                {!account.active ? t('deactivated') :
                  account.lastActive
                    ? <Date date={account.lastActive as Date} showTime />
                    : t('no_activity')
                }
              </div>
            ),
            [t('fields.records')]: (
              <span className={account.active ? '' : 'inactive'}>{account.records}</span>
            ),
            [t('filtersAlert')]: (
              <div>
                {account.active && account.filters && account.filters.filter((filter: Filter) => filter.profile === 'alert').map((filter: Filter) => (
                  <div key={filter.id}>
                    {filter.count > 0 && (
                      <AlertText text={`${filter.count} ${filter.name}`} />
                    )}
                  </div>
                ))}
              </div>
            ),
            [t('filtersWarn')]: (
              <div>
                {account.active && account.filters && account.filters.filter((filter: Filter) => filter.profile === 'warn').map((filter: Filter) => (
                  <div key={filter.id}>
                    {filter.count > 0 && (
                      <WarningText text={`${filter.count} ${filter.name}`} />
                    )}
                  </div>
                ))}
              </div>
            )            
          }}
        />
      </div>
    </>
  )
}

export default AccountsRowCompact
